import { atom } from 'jotai'

type SelectedItem = {
  id: string
  origin: 'table' | 'map'
}
export const selectedItem = atom<SelectedItem | undefined>(undefined)
